<template>
  <div class="filters">
    <app-switch
      v-for="(item, index) in filters"
      :key="index"
      :payload="item"
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

import AppSwitch from '@/components/UI/Switch.vue';

export default {
  name: 'Filters',
  components: {
    AppSwitch,
  },
  props: {
    customFilters: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      defaultFilters: {
        relative: {
          name: 'include inner links',
          checked: false,
          slug: 'relative-filter',
          disabled: true,
        },
        bigFive: {
          name: 'show big tech',
          checked: false,
          slug: 'big-five-filter',
          disabled: false,
        },
        fullUrl: {
          name: 'show full urls',
          checked: false,
          slug: 'domains-only',
          disabled: false,
        },
      },
    };
  },
  computed: {
    filters() {
      return this.customFilters ? this.customFilters : this.defaultFilters;
    },
  },
  methods: {
    ...mapMutations('Filters', [
      'setFilters',
    ]),
  },
  watch: {
    filters: {
      handler(obj) {
        this.setFilters(obj);
      },
      deep: true,
    },
  },
};
</script>
